import React, { Component } from 'react';
import {Container, Grid, Icon, Button, Modal, Header} from 'semantic-ui-react'
import {notify} from 'react-notify-toast';
import { translate } from 'react-i18next';
import API from '../utils/API'
var fileDownload = require('js-file-download');

class PersonalDataCard extends Component {

  constructor(props) {
    super(props)
    this.state = {
      pdataFetching: false,
      deleteFetching: false,
      deleteModalOpen: false,
      headerOpened: false
    }
    this.toggleHeader = this.toggleHeader.bind(this)
  }

  toggleHeader() {
    this.setState(prevState => ({headerOpened: !prevState.headerOpened}))
  }

  async downloadPersonalData() {
    this.setState({pdataFetching: true})
    const response = await API.getUserPersonalData()
      if (response.ok) {
        this.setState({pdataFetching: false})
        fileDownload(JSON.stringify(response.data), 'GOWOD_data.json');
      } else {
        notify.show(this.props.t('messages:pdataKO'), 'error')
        this.setState({pdataFetching: false})
      }
  }

  async deleteAccount () {
    this.setState({deleteFetching: true})
    const response = await API.deleteUserAccount()
      if (response.ok) {
        this.setState({deleteFetching: false})
        delete window.localStorage.gwps
        window.location.reload()
      } else {
        notify.show(this.props.t('messages:deleteKO'), 'error')
        this.setState({deleteFetching: false})
      }
  }

  render() {
    const { t } = this.props
    const { headerOpened, pdataFetching, deleteFetching, deleteModalOpen } = this.state
    return (
      <div className="mobile-card" id="pdata-card">
        <div className="mobile-card-header" onClick={this.toggleHeader}>
            <h3>{t('tabs:pdata')}</h3>
            {!headerOpened && <Icon className="caret-icons" size="large" name='caret down' />}
            {headerOpened && <Icon className="caret-icons" size="large" name='caret up' />}
        </div>
        <div className="mobile-card-content" style={!headerOpened ? {display: 'none'} : {}}>
          <p>{t('pdata:title')}</p>
          <ul>
            <li>{t('pdata:part1')}</li>
            <li>{t('pdata:part2')}</li>
            <li>{t('pdata:part3')}</li>
          </ul>
          <Button fluid icon loading={pdataFetching} onClick={this.downloadPersonalData.bind(this)}>
            {t('pdata:download')}
          </Button>
          <Button fluid basic color='red' icon onClick={() => this.setState({deleteModalOpen: true})}>
            {t('pdata:delete')}
          </Button>
        </div>   
        <Modal closeIcon open={deleteModalOpen} onClose={() => this.setState({deleteModalOpen: false})}>
          <Modal.Content>
            <Modal.Description>
                <Header>{t('pdata:deleteModal.title')}</Header>
                <p>{t('pdata:deleteModal.part1')} <br/>
                {t('pdata:deleteModal.part2')} <b>{t('pdata:deleteModal.part3')}</b>.
                </p>
                <p>{t('pdata:deleteModal.part4')} <br/> {t('pdata:deleteModal.part5')}: <a href="https://support.apple.com/HT202039">https://support.apple.com/HT202039</a></p>
                <div className="text-center mt30">
                  <Button color='grey' negative loading={deleteFetching} onClick={this.deleteAccount.bind(this)}>{t('common:delete')}</Button>
                </div>
            </Modal.Description>
          </Modal.Content>
        </Modal> 
      </div>
    )
  }
}
 
export default translate('translations')(PersonalDataCard);


// WEBPACK FOOTER //
// ./src/components/PersonalDataCard.js